import React from 'react';
import SuperAdminDashboard from './SuperAdminDashboard';

// Admin sees the same panorama as Super Admin (backend delete/reject restrictions
// enforce the difference). Kept as a distinct component to allow future divergence.
export default function AdminDashboard() {
  return <SuperAdminDashboard />;
}
